const validatePage6 = (values) => {
    const maxSizeInBytes = 10485760;
    const dataLocal = JSON.parse(localStorage.getItem("dataLastStep"));
    const creadorCultural = 1;
    const gestorCultural = 2;
    const isYes = 30;
    const isNo = 31;

    const errors = {};
    if (!values.documentoDeIdentificación) {
        errors.documentoDeIdentificación =
            "Este campo es requerido, sube tu documento de identificación";
    }
    if (values.documentoDeIdentificación) {
        if (values.documentoDeIdentificación[0].type !== "application/pdf") {
            errors.documentoDeIdentificación =
                "solo esta permitido subir PDF's, debes subir un PDF";
        }
        if (values.documentoDeIdentificación[0].causal) {
            errors.documentoDeIdentificación = "Debe corregir este archivo";
        }
    }
    if (values.documentoDeIdentificación) {
        if (values.documentoDeIdentificación[0].size > maxSizeInBytes) {
            errors.documentoDeIdentificación =
                "El tamaño del archivo debe ser menor o igual a 10MB";
        }
    }
    if (!values.declaraciónJuramentadaTerceros) {
        errors.declaraciónJuramentadaTerceros =
            "Este campo es requerido, sube tu declaración juramentada realizada por tercero para acreditar trayectoria";
    }
    if (values.declaraciónJuramentadaTerceros) {
        if (
            values.declaraciónJuramentadaTerceros[0].type !== "application/pdf"
        ) {
            errors.declaraciónJuramentadaTerceros =
                "solo esta permitido subir PDF's, debes subir un PDF";
        }
        if (values.declaraciónJuramentadaTerceros[0].causal) {
            errors.declaraciónJuramentadaTerceros =
                "Debe corregir este archivo";
        }
    }
    if (values.declaraciónJuramentadaTerceros) {
        if (values.declaraciónJuramentadaTerceros[0].size > maxSizeInBytes) {
            errors.declaraciónJuramentadaTerceros =
                "El tamaño del archivo debe ser menor o igual a 10MB";
        }
    }
    if (!values.certificadoResidencia) {
        errors.certificadoResidencia =
            "Este campo es requerido, sube tu certificado de residencia";
    }
    if (values.certificadoResidencia) {
        if (values.certificadoResidencia[0].type !== "application/pdf") {
            errors.certificadoResidencia =
                "solo esta permitido subir PDF's, debes subir un PDF";
        }
        if (values.certificadoResidencia[0].causal) {
            errors.certificadoResidencia = "Debe corregir este archivo";
        }
    }
    if (values.certificadoResidencia) {
        if (values.certificadoResidencia[0].size > maxSizeInBytes) {
            errors.certificadoResidencia =
                "El tamaño del archivo debe ser menor o igual a 10MB";
        }
    }
    if (!values.certificadoAfiliaciónEps) {
        errors.certificadoAfiliaciónEps =
            "Este campo es requerido, sube tu certificado de afiliación activa a la EPS";
    }
    if (values.certificadoAfiliaciónEps) {
        if (values.certificadoAfiliaciónEps[0].type !== "application/pdf") {
            errors.certificadoAfiliaciónEps =
                "solo esta permitido subir PDF's, debes subir un PDF";
        }
        if (values.certificadoAfiliaciónEps[0].causal) {
            errors.certificadoAfiliaciónEps = "Debe corregir este archivo";
        }
    }
    if (values.certificadoAfiliaciónEps) {
        if (values.certificadoAfiliaciónEps[0].size > maxSizeInBytes) {
            errors.certificadoAfiliaciónEps =
                "El tamaño del archivo debe ser menor o igual a 10MB";
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (
            !values.certificadoRegistroObras &&
            !values.certificadoSociedadColectiva &&
            !values.certificadoContratos &&
            !values.otrosSoportesTrayectoria &&
            !values.tarjetaProfesional
        ) {
            errors.certificadoRegistroObras =
                "Debes subir al menos un documento que te acredite como creador cultural";
            errors.certificadoSociedadColectiva =
                "Debes subir al menos un documento que te acredite como creador cultural";
            errors.certificadoContratos =
                "Debes subir al menos un documento que te acredite como creador cultural";
            errors.otrosSoportesTrayectoria =
                "Debes subir al menos un documento que te acredite como creador cultural";
            errors.tarjetaProfesional =
                "Debes subir al menos un documento que te acredite como creador cultural";
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.certificadoRegistroObras) {
            if (values.certificadoRegistroObras[0].type !== "application/pdf") {
                errors.certificadoRegistroObras =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.certificadoRegistroObras[0].causal) {
                errors.certificadoRegistroObras = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.certificadoRegistroObras) {
            if (values.certificadoRegistroObras[0].size > maxSizeInBytes) {
                errors.certificadoRegistroObras =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.certificadoSociedadColectiva) {
            if (
                values.certificadoSociedadColectiva[0].type !==
                "application/pdf"
            ) {
                errors.certificadoSociedadColectiva =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.certificadoSociedadColectiva[0].causal) {
                errors.certificadoSociedadColectiva =
                    "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.certificadoSociedadColectiva) {
            if (values.certificadoSociedadColectiva[0].size > maxSizeInBytes) {
                errors.certificadoSociedadColectiva =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.certificadoContratos) {
            if (values.certificadoContratos[0].type !== "application/pdf") {
                errors.certificadoContratos =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.certificadoContratos[0].causal) {
                errors.certificadoContratos = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.certificadoContratos) {
            if (values.certificadoContratos[0].size > maxSizeInBytes) {
                errors.certificadoContratos =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.otrosSoportesTrayectoria) {
            if (values.otrosSoportesTrayectoria[0].type !== "application/pdf") {
                errors.otrosSoportesTrayectoria =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.otrosSoportesTrayectoria[0].causal) {
                errors.otrosSoportesTrayectoria = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.otrosSoportesTrayectoria) {
            if (values.otrosSoportesTrayectoria[0].size > maxSizeInBytes) {
                errors.otrosSoportesTrayectoria =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.tarjetaProfesional) {
            if (values.tarjetaProfesional[0].type !== "application/pdf") {
                errors.tarjetaProfesional =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.tarjetaProfesional[0].causal) {
                errors.tarjetaProfesional = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === creadorCultural) {
        if (values.tarjetaProfesional) {
            if (values.tarjetaProfesional[0].size > maxSizeInBytes) {
                errors.tarjetaProfesional =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === gestorCultural) {
        if (!values.soporteTrayectoriaGestor && !values.otrosSoportesGestor) {
            errors.soporteTrayectoriaGestor =
                "Debes subir al menos un documento que te acredite como gestor cultural";
            errors.otrosSoportesGestor =
                "Debes subir al menos un documento que te acredite como gestor cultural";
        }
    }
    if (dataLocal?.datos_personales?.usted === gestorCultural) {
        if (values.soporteTrayectoriaGestor) {
            if (values.soporteTrayectoriaGestor[0].type !== "application/pdf") {
                errors.soporteTrayectoriaGestor =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.soporteTrayectoriaGestor[0].causal) {
                errors.soporteTrayectoriaGestor = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === gestorCultural) {
        if (values.soporteTrayectoriaGestor) {
            if (values.soporteTrayectoriaGestor[0].size > maxSizeInBytes) {
                errors.soporteTrayectoriaGestor =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === gestorCultural) {
        if (values.otrosSoportesGestor) {
            if (values.otrosSoportesGestor[0].type !== "application/pdf") {
                errors.otrosSoportesGestor =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.otrosSoportesGestor[0].causal) {
                errors.otrosSoportesGestor = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.datos_personales?.usted === gestorCultural) {
        if (values.otrosSoportesGestor) {
            if (values.otrosSoportesGestor[0].size > maxSizeInBytes) {
                errors.otrosSoportesGestor =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (
        dataLocal?.datos_personales?.usted === creadorCultural ||
        dataLocal?.datos_personales?.usted === gestorCultural
    ) {
        if (
            !values.soportesDeSocialización &&
            !values.premios &&
            !values.certificaciónEventos
        ) {
            errors.soportesDeSocialización =
                "Debes subir al menos un documento que te acredite como gestor o creador cultural";
            errors.premios =
                "Debes subir al menos un documento que te acredite como gestor o creador cultural";
            errors.certificaciónEventos =
                "Debes subir al menos un documento que te acredite como gestor o creador cultural";
        }
    }
    if (
        dataLocal?.datos_personales?.usted === creadorCultural ||
        dataLocal?.datos_personales?.usted === gestorCultural
    ) {
        if (values.soportesDeSocialización) {
            if (values.soportesDeSocialización[0].type !== "application/pdf") {
                errors.soportesDeSocialización =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.soportesDeSocialización[0].causal) {
                errors.soportesDeSocialización = "Debe corregir este archivo";
            }
        }
    }
    if (
        dataLocal?.datos_personales?.usted === creadorCultural ||
        dataLocal?.datos_personales?.usted === gestorCultural
    ) {
        if (values.soportesDeSocialización) {
            if (values.soportesDeSocialización[0].size > maxSizeInBytes) {
                errors.soportesDeSocialización =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (
        dataLocal?.datos_personales?.usted === creadorCultural ||
        dataLocal?.datos_personales?.usted === gestorCultural
    ) {
        if (values.premios) {
            if (values.premios[0].type !== "application/pdf") {
                errors.premios =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.premios[0].causal) {
                errors.premios = "Debe corregir este archivo";
            }
        }
    }
    if (
        dataLocal?.datos_personales?.usted === creadorCultural ||
        dataLocal?.datos_personales?.usted === gestorCultural
    ) {
        if (values.premios) {
            if (values.premios[0].size > maxSizeInBytes) {
                errors.premios =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (
        dataLocal?.datos_personales?.usted === creadorCultural ||
        dataLocal?.datos_personales?.usted === gestorCultural
    ) {
        if (values.certificaciónEventos) {
            if (values.certificaciónEventos[0].type !== "application/pdf") {
                errors.certificaciónEventos =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.certificaciónEventos[0].causal) {
                errors.certificaciónEventos = "Debe corregir este archivo";
            }
        }
    }
    if (
        dataLocal?.datos_personales?.usted === creadorCultural ||
        dataLocal?.datos_personales?.usted === gestorCultural
    ) {
        if (values.certificaciónEventos) {
            if (values.certificaciónEventos[0].size > maxSizeInBytes) {
                errors.certificaciónEventos =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.sistema_salud?.tiene_discapacidad === isYes) {
        if (!values.certificaciónDiscapacidad) {
            errors.certificaciónDiscapacidad =
                "Este campo es requerido, sube tu certificado de discapacidad";
        }
    }
    if (dataLocal?.sistema_salud?.tiene_discapacidad === isYes) {
        if (values.certificaciónDiscapacidad) {
            if (
                values.certificaciónDiscapacidad[0].type !== "application/pdf"
            ) {
                errors.certificaciónDiscapacidad =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.certificaciónDiscapacidad[0].causal) {
                errors.certificaciónDiscapacidad = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.sistema_salud?.tiene_discapacidad === isYes) {
        if (values.certificaciónDiscapacidad) {
            if (values.certificaciónDiscapacidad[0].size > maxSizeInBytes) {
                errors.certificaciónDiscapacidad =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (
        dataLocal?.nivel_socioeconomico?.con_quien_reside == 24 &&
        dataLocal?.nivel_socioeconomico?.dependende_economicamente == isNo
    ) {
        if (!values.declaraciónJuramentadaAdultoMayor) {
            errors.declaraciónJuramentadaAdultoMayor =
                "Este campo es requerido, sube tu certificado de discapacidad";
        }
    }
    if (
        dataLocal?.nivel_socioeconomico?.con_quien_reside == 24 &&
        dataLocal?.nivel_socioeconomico?.dependende_economicamente == isNo
    ) {
        if (values.declaraciónJuramentadaAdultoMayor) {
            if (
                values.declaraciónJuramentadaAdultoMayor[0].type !==
                "application/pdf"
            ) {
                errors.declaraciónJuramentadaAdultoMayor =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.declaraciónJuramentadaAdultoMayor[0].causal) {
                errors.declaraciónJuramentadaAdultoMayor =
                    "Debe corregir este archivo";
            }
        }
    }
    if (
        dataLocal?.nivel_socioeconomico?.con_quien_reside == 24 &&
        dataLocal?.nivel_socioeconomico?.dependende_economicamente == isNo
    ) {
        if (values.declaraciónJuramentadaAdultoMayor) {
            if (
                values.declaraciónJuramentadaAdultoMayor[0].size >
                maxSizeInBytes
            ) {
                errors.declaraciónJuramentadaAdultoMayor =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (dataLocal?.nivel_socioeconomico?.puntaje_sisben == isYes) {
        if (!values.certificaciónSisben) {
            errors.certificaciónSisben =
                "Este campo es requerido, sube tu certificado de Sisben";
        }
    }
    if (dataLocal?.nivel_socioeconomico?.puntaje_sisben == isYes) {
        if (values.certificaciónSisben) {
            if (values.certificaciónSisben[0].type !== "application/pdf") {
                errors.certificaciónSisben =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.certificaciónSisben[0].causal) {
                errors.certificaciónSisben = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.nivel_socioeconomico?.puntaje_sisben == isYes) {
        if (values.certificaciónSisben) {
            if (values.certificaciónSisben[0].size > maxSizeInBytes) {
                errors.certificaciónSisben =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    // if (dataLocal?.nivel_socioeconomico?.hace_parte_listado_censal == isYes) {
    //     if (!values.soporteListadoCensal) {
    //         errors.soporteListadoCensal =
    //             "Este campo es requerido, sube tu soporte de listado censal";
    //     }
    // }
    if (dataLocal?.nivel_socioeconomico?.hace_parte_listado_censal == isYes) {
        if (values.soporteListadoCensal) {
            if (values.soporteListadoCensal[0].type !== "application/pdf") {
                errors.soporteListadoCensal =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.soporteListadoCensal[0].causal) {
                errors.soporteListadoCensal = "Debe corregir este archivo";
            }
        }
    }
    if (dataLocal?.nivel_socioeconomico?.hace_parte_listado_censal == isYes) {
        if (values.soporteListadoCensal) {
            if (values.soporteListadoCensal[0].size > maxSizeInBytes) {
                errors.soporteListadoCensal =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (
        dataLocal?.situacion_laboral?.ingresos_actuales == 76 &&
        dataLocal?.sistema_salud?.hace_parte_agremiacion_asociacion_salud ==
            isYes
    ) {
        if (!values.certificaciónAgremiación) {
            errors.certificaciónAgremiación =
                "Este campo es requerido, sube tu soporte de agremiación o asociación que cubre tu salud";
        }
    }
    if (
        dataLocal?.situacion_laboral?.ingresos_actuales == 76 &&
        dataLocal?.sistema_salud?.hace_parte_agremiacion_asociacion_salud ==
            isYes
    ) {
        if (values.certificaciónAgremiación) {
            if (values.certificaciónAgremiación[0].type !== "application/pdf") {
                errors.certificaciónAgremiación =
                    "solo esta permitido subir PDF's, debes subir un PDF";
            }
            if (values.certificaciónAgremiación[0].causal) {
                errors.certificaciónAgremiación = "Debe corregir este archivo";
            }
        }
    }
    if (
        dataLocal?.situacion_laboral?.ingresos_actuales == 76 &&
        dataLocal?.sistema_salud?.hace_parte_agremiacion_asociacion_salud ==
            isYes
    ) {
        if (values.certificaciónAgremiación) {
            if (values.certificaciónAgremiación[0].size > maxSizeInBytes) {
                errors.certificaciónAgremiación =
                    "El tamaño del archivo debe ser menor o igual a 10MB";
            }
        }
    }
    if (!values.términos) {
        errors.términos =
            "Este campo es requerido , debe aceptar los términos y condiciones";
    }
    return errors;
};

export default validatePage6;
